module.exports = __webpack_public_path__ + "static/media/44464905_2199884163420096_8596938803191480320_o-thumb.1972b955.jpg";